import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:8000/api";
// Stable per-browser device fingerprint (offline device authorization).
export function deviceFingerprint() {
  let fp = localStorage.getItem("mc_device_fp");
  if (!fp) {
    const raw = [navigator.userAgent, navigator.language, screen.width, screen.height,
      new Date().getTimezoneOffset(), Math.random().toString(36).slice(2)].join("|");
    let h = 0;
    for (let i = 0; i < raw.length; i++) h = (h * 31 + raw.charCodeAt(i)) | 0;
    fp = `MC-${Math.abs(h).toString(16).toUpperCase()}`;
    localStorage.setItem("mc_device_fp", fp);
  }
  return fp;
}

export function deviceName() {
  const ua = navigator.userAgent;
  const os = /Windows/.test(ua) ? "Windows" : /Mac/.test(ua) ? "macOS" : /Linux/.test(ua) ? "Linux" : "Device";
  const br = /Edg/.test(ua) ? "Edge" : /Chrome/.test(ua) ? "Chrome" : /Firefox/.test(ua) ? "Firefox" : "Browser";
  return `${os} · ${br}`;
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("mc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-Device-Fingerprint"] = deviceFingerprint();
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && sessionStorage.getItem("mc_token")) {
      sessionStorage.removeItem("mc_token");
      window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function errMsg(e) {
  return apiError(e.response?.data?.detail) || e.message;
}

export async function openPdf(path) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  window.open(url, "_blank");
  return url;
}
